
/**
 * need
 * INSERT
 * DELETE
 * UPDATE
 */

import { CONFIG_API } from "@/plugins/axios";
import { jsonParams } from "./Utils";

export default class Filter {
    constructor(item) {
        this.id = item.id;
        this.name = item.name;
        this.referenceValue = item.reference_value;
        this.filterRange = item.finter_range;
        this.filterStep = item.finter_step;
        this.eu = item.eu;
        this.category = item.category;
        this.component = item.component;
    }
}

export async function getFilters(params) {
    try {
        const headers = {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            "Authorization": "JWT " + localStorage.getItem("config_token"),
        };
        params = jsonParams(params);
        const config = { headers, params };
        let res = await CONFIG_API.get("filters/", config);
        if (res && res.status == 200) {
            let data = res.data.map(e => new Filter(e));
            return data;
        }
    } catch (e) {
        console.error(e);
        return [];
    }
}


export async function insertFilters(data) {
    try {
        const headers = {
            "Content-Type": "application/json; charset=utf-8",
            "Authorization": "JWT " + localStorage.getItem("config_token"),
        };
        const config = { headers };

        let res = await CONFIG_API.post("filters/", data, config);
        return res;
    } catch (e) {
        console.error(e);
        return e;
    }
}
